import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M16 32C24.8366 32 32 24.8365 32 16C32 7.16345 24.8366 0 16 0C7.16344 0 0 7.16345 0 16C0 24.8365 7.16344 32 16 32ZM21.8359 13.3936L21.2136 17.375H17.9452V27H13.5617V17.375H10V13.3936H13.5617V10.359C13.5617 6.90698 15.656 5 18.8602 5C20.3949 5 22 5.26904 22 5.26904V8.65881H20.2312C18.4887 8.65881 17.9452 9.72058 17.9452 10.8098V13.3936H21.8359Z'],
  name: 'brandCircleFB',
  oldName: 'cubCircleFB'
} as IconDefinition
